import styled from "styled-components";

export const StyledSwitchLabel = styled.label<{ height: number }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: ${({ height }) => `${height}px`};
  padding: 4px 8px;
  border-radius: 35px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 0.5);

  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px dashed ${({ theme }) => theme.palette.borderColor};
`;

export const StyledSwitchInput = styled.input`
  display: none;

  &:checked + div {
    box-shadow: inset 32px -32px 0 0 #fff;
    transform: scale(0.5) rotate(0deg);
    transition:
      transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.1s,
      box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  }

  &:checked + div::before {
    background: ${({ theme }) => theme.palette.switcher.lightColor};
    transition: background 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.15s;
  }

  &:checked + div::after {
    transform: scale(1.5);
    transition: transform 0.7s cubic-bezier(0.4, 0, 0.2, 1) 0.2s;
  }
`;

export const StyledSwitchDiv = styled.div`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: relative;
  box-shadow: inset 8px -8px 0 0 ${({ theme }) => theme.palette.switcher.darkBg};
  transform: scale(1) rotate(-2deg);
  transition:
    box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0s,
    transform 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.1s;

  &::before {
    content: "";
    width: inherit;
    height: inherit;
    border-radius: inherit;
    position: absolute;
    left: 0;
    top: 0;
    transition: background 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &::after {
    content: "";
    width: 4px;
    height: 4px;
    border-radius: 50%;
    margin: -2px 0 0 -2px;
    position: absolute;
    top: 50%;
    left: 50%;
    box-shadow:
      0 -12px 0 ${({ theme }) => theme.palette.switcher.lightColor},
      0 12px 0 ${({ theme }) => theme.palette.switcher.lightColor},
      12px 0 0 ${({ theme }) => theme.palette.switcher.lightColor},
      -12px 0 0 ${({ theme }) => theme.palette.switcher.lightColor},
      9px 9px 0 ${({ theme }) => theme.palette.switcher.lightColor},
      -9px 9px 0 ${({ theme }) => theme.palette.switcher.lightColor},
      9px -9px 0 ${({ theme }) => theme.palette.switcher.lightColor},
      -9px -9px 0 ${({ theme }) => theme.palette.switcher.lightColor};
    transform: scale(0);
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
